import 'css-chunk:src/components/pages/AnalyzePage/BreakdownView/BreakdownView.scss';export default {
  "BreakdownView": "_BreakdownView_1ujm0_1",
  "GroupByLabel": "_GroupByLabel_1ujm0_1",
  "GroupByButton": "_GroupByButton_1ujm0_6",
  "active": "_active_1ujm0_20"
};